import { render } from "./CrawlInProgress.vue?vue&type=template&id=1724bfdc&scoped=true"
import script from "./CrawlInProgress.vue?vue&type=script&lang=js"
export * from "./CrawlInProgress.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1724bfdc"

export default script